import React from 'react';

function UpcomingPayments() {
  const paymentData = [
    {
      schoolName: 'ABC Public School',
      nextPaymentDate: '10-Apr-2026',
      amount: '₹50,000'
    },
    {
      schoolName: 'XYZ High School',
      nextPaymentDate: '15-Apr-2026',
      amount: '₹75,000'
    },
    {
      schoolName: 'Green Valley School',
      nextPaymentDate: '20-Apr-2026',
      amount: '₹30,000'
    }
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h1>Upcoming Payments</h1>

      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '20px'
        }}
      >
        <thead>
          <tr>
            <th style={tableHeader}>School Name</th>
            <th style={tableHeader}>Next Payment Date</th>
            <th style={tableHeader}>Amount</th>
          </tr>
        </thead>

        <tbody>
          {paymentData.map((payment, index) => (
            <tr key={index}>
              <td style={tableCell}>{payment.schoolName}</td>
              <td style={tableCell}>{payment.nextPaymentDate}</td>
              <td style={tableCell}>{payment.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const tableHeader = {
  border: '1px solid #1a0909',
  padding: '12px',
  textAlign: 'left',
  backgroundColor: '#f7cfcf'
};

const tableCell = {
  border: '1px solid #150909',
  padding: '12px'
};

export default UpcomingPayments;